var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSitevisitsuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9796_114930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8583 1.93115H4.28683C2.70887 1.93115 1.42969 3.21034 1.42969 4.7883V36.2169C1.42969 37.7949 2.70887 39.074 4.28683 39.074H30.0011C31.5791 39.074 32.8583 37.7949 32.8583 36.2169V23.3597M1.42969 30.5026H32.8583M10.0011 9.07401H15.7154M10.0011 16.2169H12.8583M25.6987 21.9477L17.1272 23.4906L18.5558 14.8049L30.6414 2.77629C30.9071 2.5085 31.2231 2.29594 31.5714 2.15089C31.9194 2.00583 32.2928 1.93115 32.67 1.93115C33.0474 1.93115 33.4208 2.00583 33.7688 2.15089C34.1171 2.29594 34.4331 2.5085 34.6985 2.77629L37.7271 5.80487C37.9951 6.07047 38.2077 6.38647 38.3525 6.73464C38.4977 7.08281 38.5723 7.45627 38.5723 7.83344C38.5723 8.21061 38.4977 8.58407 38.3525 8.93221C38.2077 9.28038 37.9951 9.59641 37.7271 9.86201L25.6987 21.9477Z",
    stroke: "#0E9349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9796_114930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitevisitsuccess);
export default __webpack_public_path__ + "static/media/sitevisitsuccess.91a8fe646754750a065a92a88ac95043.svg";
export { ForwardRef as ReactComponent };